<template>
<div>
	<header>
		<div>
			<router-link to="/conversations/new" class="btn-primary post">
                Verfassen
            </router-link>
		</div>
		<h1>Nachrichten</h1>
	</header>
	<div id="conversations">
		<router-link v-for="conversation in conversations" 
					 :to="`/conversations/${conversation.partner.id}`" 
					 :key="conversation.id"
					 :class="{ item: true, unread: !conversation.read }">
			<dp :who="conversation.partner" />
			<h3>{{ conversation.partner | name }}</h3>
			<p>{{ conversation.message }}</p>
		</router-link>
	</div>
</div>
</template>

<script>
import base from 'base.vue'
import dp from 'components/dp.vue'

export default {
	name: 'conversations',
	mixins: [ base ],
	components: { dp },
	data () {
		return {
			conversations: [ ],
			updateTimer: ''
		}
	},
	methods: {
		fetchData () {
			const that = this

			return this.$api.get('conversations')
			.then(response => {
				that.conversations = response.data
			})
			.finally(() => {
				if (that.fetchData !== undefined) {
					that.updateTimer = setTimeout(that.fetchData, 5000)
				}
			})
		}
	},
	created () {
		// The conversations page is excluded from keep-alive, so we can use the created-hook
		this.updateTimer = setTimeout(this.fetchData, 5000)
	},
	deactivated () {
		clearTimeout(this.updateTimer)
	},
	beforeDestroy () {
		clearTimeout(this.updateTimer)
	}
}
</script>


// WEBPACK FOOTER //
// conversations.vue?1a903231